import { render, staticRenderFns } from "./year-table.vue?vue&type=template&id=0221a345&scoped=true"
import script from "./year-table.vue?vue&type=script&lang=js"
export * from "./year-table.vue?vue&type=script&lang=js"
import style0 from "./year-table.vue?vue&type=style&index=0&id=0221a345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221a345",
  null
  
)

export default component.exports